import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Submenu from './sub-menu';
import {TrackSelection} from './index';
import I18n from '../i18n';

export default function List(props) {
  const {onClick, data, index, activeIndex, ...rest} = props;
  const {ids} = props;
  ids.push(data.id);
  const {selected, handleSelected} = React.useContext(TrackSelection);

  const handleItemClick = React.useCallback((event, index) => {
    data.submenu ? onClick(event, index) : handleSelected(ids);
  });

  return (
    <li
      className={classnames(
        activeIndex === index ? 'open' : '',
        selected.indexOf(data.id) !== -1 ? 'selected' : '',
        Boolean(data.submenu) ? 'dropdown-submenu' : '',
      )}
      onClick={event => handleItemClick(event, index)}
      {...rest}
    >
      <a>{I18n.t(data.menu)}</a>
      {Boolean(data.submenu && activeIndex === index) && <Submenu options={data.submenu} ids={ids} />}
    </li>
  );
}

List.defaultProps = {};

List.propTypes = {
  /** A callback to execute when list items are clicked. Will be passed the list event and index */
  onClick: PropTypes.func,
  /** An object passed to the component for dropdown menu */
  data: PropTypes.object,
  /** Index of list item */
  index: PropTypes.number,
  /** Indes of active list item */
  activeIndex: PropTypes.number,
  /** Selected ids of list item */
  ids: PropTypes.array,
};
